import data from "../../shared/sharedData";

export default {
  name: "Place of Employment Information",
  prefix: "C",
  sections: [
    {
      fields: [
        {
          code: "C.1",
          machine_name: "eta_790a_c1_work_address",
          widget: "text_area",
          label: "Place of Employment <br/> <br/> Address/Location",
          validate: [
            "required",
            {
              minLength: 4,
              message: "Address/Location must contain at least 4 characters.",
            },
          ],
          tooltip: `Enter the street address of the location where work will be performed. The place of employment address must be a
            physical location and cannot be a P.O. box. For a rural or other location without a street address, enter “<b>NONE</b>” and
            provide as much information in Items C.2 through C.5 as possible, supplemented with additional information in Item B.6`,
          info: {
            text: "Enter the business street address of the employer’s point of contact. A P.O. Box is a mailing address and not a valid physical address location and, when disclosed on this application, the CO will issue a NOD requesting removal of the P.O. Box mailing address and provide the employer with an opportunity to amend the application with a valid physical address location.",
            coloring: "grey",
            divider: false,
            css: {
              marginTop: 20,
              marginBottom: 10,
            },
          },
          rows: 5,
          placeholder: "",
          inputLimit: 120,
        },
        {
          code: "C.2",
          machine_name: "eta_790a_c2_work_city",
          widget: "text",
          label: "City",
          validate: [
            "required",
            {
              minLength: 2,
              message: "City must contain at least 2 characters.",
            },
          ],
          tooltip: `Enter the city in which the place of employment is located.`,
          placeholder: "",
          maxLength: 45,
        },
        {
          code: "C.3",
          machine_name: "eta_790a_c3_work_state_id",
          widget: "select",
          selection: data.state,
          state: true,
          label: "State",
          validate: ["required"],
          tooltip: `Enter the State/District/Territory in which the place of employment is located.`,
          placeholder: "",
          // warning:{
          //   text:"The wage is less than the Adverse Effect Wage Rate.",
          //   isVisible: {
          //     when: 'eta_790a_a8b_wage_offer',
          //     is: ['eta_790a_c3_work_state_id','eta_790a_a8c_wage_offer_per', 'hour'],
          //     operator: 'minWageComparison'
          //   }
          // }
        },
        {
          code: "C.4",
          machine_name: "eta_790a_c4_work_zip",
          widget: "text",
          label: "Postal Code",
          validate: ["required", "postal"],
          message: "This field cannot be more than 10 characters long.",
          maxLength: 10,
          tooltip: `Enter the postal (zip) code in which the place of employment is located.`,
          placeholder: "",
        },
        {
          code: "C.5",
          machine_name: "eta_790a_c5_work_county_id",
          widget: "countyselect",
          label: "County",
          required: true,
          validate: [
            "required",
            {
              required_county: "eta_790a_c3_work_state_id",
              message: "",
              needsFieldValues: true,
            },
          ],
          tooltip: `Enter the county in which the place of employment is located.`,
          disabled: true,
          disableWhenField: "eta_790a_c3_work_state_id",
          placeholder: "",
        },
      ],
    },
    {
      fields: [
        {
          code: "C.6",
          machine_name: "eta_790a_c6_work_additional_info",
          widget: "text_area",
          label:
            'Additional Place of Employment Information and Crop or Agricultural Activity (if no additional information, enter "<u><strong>NONE</strong></u>" below).',
          validate: ["required"],
          message: "This field cannot be more than 500 characters long.",
          tooltip: `6.	Enter any additional information about the place of employment location <strong><u>AND</u></strong> identify the crop(s) or agricultural activity(ies) that workers will perform at this location.  Examples of additional place of employment information may include more specific information about the fields where work will be performed in close proximity to the address location, more specific directions on how workers can reach the place of employment, and/or Global Positioning System (GPS) coordinates, especially in very rural and isolated geographic areas.  If no additional information concerning the place of employment is needed, enter "<u><strong>NONE</strong></u>" below.`,
          rows: 8,
          placeholder: "",
          inputLimit: 500,
        },
      ],
    },
    {
      name: "Additional Place of Employment",
      fields: [
        {
          isGroup: {
            code: "C.7",
            machine_name: "eta_790a_c7_is_work_addendum_b_completed", //not sure if this is the correct machine name for this field
            label:
              "Will work be performed at worksite locations or through additional Agricultural Businesses other than the ones identified above?",
            tooltip: `In circumstances where work needs to be performed at additional places of employment other than the address listed in
              Items 1 through 5 above, select “Yes” and submit a completed Form ETA-790A, Addendum B, identifying all additional
              places of employment and, where required, the agricultural business that will employ workers, or to whom the employer will be providing workers. If work will not be performed at additional places of employment other than the address listed in
              items 1 through 5 above, select “<b>N/A</b>.”`,
            coloring: "none",
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: ["required"],
                clearSchema: ["eta_790a_addendum_b_employment", "agBusinesses"],
              },
            ],
          },
        },
      ],
    },
  ],
};
